import { BulkDiscountTier } from 'common/BulkDiscountUtils';
import { formatCurrency } from 'common/FormatUtilities';
import {
  BREAKDOWN_DISCOUNTED_DELIVERY_TEXT,
  BREAKDOWN_DISCOUNT_TEXT,
  BREAKDOWN_DISCOUNT_YOUR_ORDER_TEXT,
  BREAKDOWN_PERCENT_OFF_TEXT,
} from 'src/shared/design-system/BulkDiscount';
import { DiscountText, SpendText } from 'src/shared/design-system/BulkDiscount/BulkDiscountBreakdown/styles';
import { TextReplace } from 'src/shared/design-system/Utilities';
import { getPercentFromDecimal } from 'src/shared/utils/NumberUtils';

interface BulkDiscountModalBodyProps {
  bulkDiscountTiers: BulkDiscountTier[];
  discountedDeliveryFee: number;
  deliveryFree: number;
  loading: boolean;
}

export const BulkDiscountModalBody: React.FC<BulkDiscountModalBodyProps> = ({
  bulkDiscountTiers,
  discountedDeliveryFee,
  loading,
}) => {
  if (loading || bulkDiscountTiers.length === 0) {
    return null;
  }

  return (
    <div className='mx-auto mb-4 w-80'>
      <div className='mx-auto flex w-full flex-col items-center gap-1 rounded-lg bg-neutral-50 py-6 text-sm'>
        {bulkDiscountTiers.map(({ minSubtotal, discountRate }, index) => {
          const isFreeDelivery = discountRate === 0 && index === 0;
          const discountText = isFreeDelivery ? (
            <TextReplace
              replaceText={[discountedDeliveryFee === 0 ? 'Free' : formatCurrency(discountedDeliveryFee)]}
              text={BREAKDOWN_DISCOUNTED_DELIVERY_TEXT}
            />
          ) : (
            ` ${getPercentFromDecimal(discountRate).toFixed(0)}${BREAKDOWN_PERCENT_OFF_TEXT}`
          );

          return (
            <TextReplace
              key={`bulk-tier-${index}`}
              replaceText={[
                <SpendText key={`spend-text-${index}`}>{formatCurrency(minSubtotal, true)}</SpendText>,
                <DiscountText key={`discount-text-${index}`} className='text-kale-500'>
                  {discountText}
                </DiscountText>,
                isFreeDelivery ? '' : BREAKDOWN_DISCOUNT_YOUR_ORDER_TEXT,
              ]}
              text={BREAKDOWN_DISCOUNT_TEXT}
            />
          );
        })}
      </div>
    </div>
  );
};
